<template>
    <div id="app">
        <router-view />
        <div class="useful" v-if="onlineServiceObj && onlineServiceObj.resourceContUrl">
            <div class="tooltip">
                <img
                    src="/static/image/AI_useful.gif"
                    alt=""
                    @click="goOnlineService(onlineServiceObj.resourceContUrl)"
                />
                <span class="tooltiptext" v-if="tooltipShow">
                    <div class="tooltipbtn">
                        <span>{{ $t("common.customer") }}</span
                        ><van-icon name="cross" @click="tooltipShow = false" />
                    </div>
                    <div>{{ $t("common.customerContent") }}</div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "App",
    components: {},
    data() {
        return {
            onlineService: "",
            tooltipShow: true,
            onlineServiceObj: {},
        };
    },
    watch: {
        // 监听，当路由发生变化的时候执行
        $route(to, from) {
            if (to.path === "/filePreview") {
                this.onlineService = false;
            } else {
                this.onlineService = true;
            }
            // this.tooltipShow = true;
            // setTimeout(() => {
            //     this.tooltipShow = false;
            // }, 2000);
            // setInterval(() => {
            //     this.tooltipShow = true;
            //     setTimeout(() => {
            //         this.tooltipShow = false;
            //     }, 2000);
            // }, 3600);
        },
    },
    mounted() {
        this.getPublicResourceInfo();
        // setTimeout(() => {
        //     this.tooltipShow = false;
        // }, 4000);
    },
    methods: {
        getPublicResourceInfo() {
            this.$api.getPublicResourceInfo().then((res) => {
                if (res.success) {
                    this.onlineServiceObj = res.data.helpSupportList.find(
                        (i) => i.type === 7
                    );
                } else {
                    this.$notify(res.msg);
                }
            });
        },
        goOnlineService(url) {
            window.location.href = url;
        },
    },
};
</script>

<style>
#app {
    height: 100%;
    background: #f7f7f8;
    overflow-y: auto;
}
html {
    height: 100%;
}
</style>
<style lang="less" scoped>
.useful {
    position: fixed;
    bottom: 12px;
    right: 0px;
    img {
        height: 90px;
    }
    // transform: rotate(-15deg);
}

.tooltip {
    position: relative;
    display: inline-block;
    .tooltiptext {
        box-sizing: content-box;
        width: 120px;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 100%; /* 定位在元素上方 */
        margin-left: -60px; /* 使用负值将提示框居中 */
        opacity: 0;
        visibility: visible;
        opacity: 1;
        font-size: 12px;
        right: 4px;
        padding: 4px 8px 4px 12px;
        div {
            margin: 0px;
            text-align: left;
        }
        &::after {
            content: "";
            position: absolute;
            top: 100%; /* 在元素下方 */
            left: 90%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #555 transparent transparent transparent; /* 创建三角形箭头 */
        }
        .tooltipbtn {
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue